import { component, property } from '../../../concepts/objects';
import { Physical, TransformHints } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Resizable } from '../../canvas/entities/Resizable';
import { reactionIconPropertyLayout } from './ReactionIconPropertyLayout';

const reactionIconDef = {
    name: 'ReactionIcon',
    implements: [
        Physical,
        Resizable,
    ],
    propertyLayout: reactionIconPropertyLayout,
};

@component(reactionIconDef)
export class ReactionIcon extends RectangularPhysical {

    @property({ type: 'string' })
    public emoji!: string;

    public get boundary() {
        return true;
    }

    public queryTransformHints(_singular: boolean): TransformHints {
        return {
            ...TransformHints.default,
            scaleMode: 'fixed',
        };
    }
}
